import {FC} from 'react';
//mui
import {Box, SxProps, Theme, Typography} from '@mui/material';
//constants
import {BODY1, OUTLINE} from '@/utils/constants';
//icons
//components
import Button from '../../Button';
import {ReactComponent as PlusIcon} from '@icons/plus.svg';
//styles
import {emptyContentStyle} from './EmptyContent.styles';

interface IEmptyContentProps {
	icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
	title: string;
	buttonTitle?: string;
	buttonIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
	onModalChange?: () => void;
	parentClassName?: SxProps<Theme>;
}

const EmptyContent: FC<IEmptyContentProps> = ({
	icon: Icon,
	title,
	buttonTitle,
	buttonIcon: ButtonIcon = PlusIcon,
	onModalChange,
	parentClassName,
}) => {
	return (
		<Box sx={{...emptyContentStyle.wrapper, ...parentClassName}}>
			<Box sx={emptyContentStyle.icon}>
				<Icon />
			</Box>

			<Typography variant={BODY1} sx={emptyContentStyle.title}>
				{title}
			</Typography>

			{buttonTitle && (
				<Button
					startIcon={<ButtonIcon />}
					title={buttonTitle}
					sx={emptyContentStyle.button}
					variant={OUTLINE}
					onClick={onModalChange}
					disableRipple
				/>
			)}
		</Box>
	);
};

export default EmptyContent;
